import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import PWALayout from './PWALayout';
import PWAHomeScreen from './PWAHomeScreen';
import PWAProductList from './PWAProductList';
import { Home, X } from 'lucide-react';

/**
 * PWA Preview Mode
 * Allows testing PWA design in browser with ?pwa=true
 */
const PWAPreview = () => {
  return (
    <div className="pwa-preview-container max-w-[430px] mx-auto bg-gray-100 min-h-screen relative shadow-2xl">
      {/* Preview Notice Banner */}
      <div className="fixed top-0 left-0 right-0 bg-yellow-500 text-yellow-900 text-xs font-medium text-center py-1 z-[100] max-w-[430px] mx-auto">
        📱 PWA Vorschau-Modus • <Link to="/" className="underline">Zurück zur Website</Link>
      </div>
      
      {/* Add padding for notice banner */}
      <div className="pt-6">
        <PWALayout>
          <PWAHomeScreen />
        </PWALayout>
      </div>
    </div>
  );
};

/**
 * PWA Product Preview
 */
export const PWAProductPreview = () => {
  return (
    <div className="pwa-preview-container max-w-[430px] mx-auto bg-gray-100 min-h-screen relative shadow-2xl">
      {/* Preview Notice Banner */}
      <div className="fixed top-0 left-0 right-0 bg-yellow-500 text-yellow-900 text-xs font-medium text-center py-1 z-[100] max-w-[430px] mx-auto">
        📱 PWA Vorschau-Modus • <Link to="/" className="underline">Zurück zur Website</Link>
      </div>
      
      {/* Add padding for notice banner */}
      <div className="pt-6">
        <PWALayout>
          <PWAProductList category="Mini-Bagger" title="Bagger" basePath="/pwa-preview/bagger" />
        </PWALayout>
      </div>
    </div>
  );
};

export default PWAPreview;
